import { IList, IRecord } from 'annotation-tools/utils';
import { ModelStatus } from '../../../types/enum/model-status';
import {
  APIRawValidationErrorType,
  APIValidationErrorType,
  IAPIValidationErrorType
} from '../common/validation-error';
import {
  ModelAPIRawRequestBodyType,
  ModelAPIRequestBodyType
} from './api-request-body';

export type ModelAPIRawSuccessResponseType = Readonly<{
  id: number;
  company_id: number;
  name: string;
  status: ModelStatus;
  author_id: number;
  adopted_version_id: number | undefined | null;
  label_count: number;
  image_count: number;
  project_count: number;
  can_be_used: boolean;
  can_be_deleted: boolean;
  created_at: string; // ISO string
  updated_at: string; // ISO string
}>;

export type ModelAPIRawValidationErrorType = APIRawValidationErrorType<
  ModelAPIRawRequestBodyType
>;

export type ModelAPIValidationErrorType = APIValidationErrorType<
  ModelAPIRequestBodyType
>;

export type IModelAPIValidationErrorType = IAPIValidationErrorType<
  ModelAPIRequestBodyType
>;

export const IModelAPIValidationErrorFactory = IRecord<
  ModelAPIValidationErrorType
>({
  name: IList<string>(),
  companyId: IList<string>(),
  adoptedVersionId: IList<string>()
});
